<div class="table-wrapper">
<table mat-table [dataSource]="dataSource" matSort class="table">

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
    <td mat-cell *matCellDef="let rule">
      <span style="font-size: 16px;">{{ rule.name }}</span>
    </td>
  </ng-container>

  <!-- Rule Type Column -->
  <ng-container matColumnDef="rule_type_display">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>TIPO</th>
    <td mat-cell *matCellDef="let rule">
      <span style="font-size: 16px;">{{ rule.rule_type_display }}</span>
    </td>
  </ng-container>

  <!-- Value Column -->
  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef>VALOR</th>
    <td mat-cell *matCellDef="let rule">
      @if (rule.rule_type === 'single_days') {
        <button mat-flat-button id="button">
          <span style="font-size: 16px;">{{ rule.boolean_value ? 'Sí' : 'No' }}</span>
        </button>
      }
      @else if (rule.value !== null) {
        <button mat-flat-button id="button">
          <span style="font-size: 16px;">{{ rule.value }}</span>
        </button>
      }
    </td>
  </ng-container>

  <!-- Date Range Column -->
  <ng-container matColumnDef="date_range">
    <th mat-header-cell *matHeaderCellDef>FECHAS</th>
    <td mat-cell *matCellDef="let rule">
      @if (rule.date_range_start && rule.date_range_end) {
        <button mat-flat-button id="button">
          <span style="font-size: 16px;">{{ rule.date_range_start }} - {{ rule.date_range_end }}</span>
        </button>
      }
    </td>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
    <td mat-cell *matCellDef="let rule">
      <button mat-icon-button (click)="goToRule(rule.id)" class="acciones">
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
      <button mat-icon-button (click)="deleteRule($event, rule.id, rule.name)" class="acciones">
        <mat-icon svgIcon="delete"></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>
